import { render, staticRenderFns } from "./ORQueueTable.vue?vue&type=template&id=10cbfacc&scoped=true"
import script from "./ORQueueTable.vue?vue&type=script&lang=js"
export * from "./ORQueueTable.vue?vue&type=script&lang=js"
import style0 from "./ORQueueTable.vue?vue&type=style&index=0&id=10cbfacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbfacc",
  null
  
)

export default component.exports